import hasPermissionQ from './hasPermissionQ'

export default function getManageUsersSidebarLinks (user) {
  let links = []
  const role = user ? user.role : null
  if (hasPermissionQ('Super Administrator', role)) {
    links.push({name: 'Manage Districts', link: '/users/manage/districts'})
  }
  if (hasPermissionQ('District Admin', role)) {
    let forceDistrict = ''
    if (role === 'District Admin') {
      forceDistrict = `/${user.schoolDistrict}`
    }
    links.push({name: 'Manage District Admins', link: `/users/manage/district-admins${forceDistrict}`})
    links.push({name: 'Manage Schools', link: `/users/manage/schools${forceDistrict}`})
  }
  if (hasPermissionQ('School Admin', role)) {
    let forceSchool = ''
    if (role === 'School Admin') {
      forceSchool = `/${user.school}`
    }
    links.push({name: 'Manage School Admins', link: `/users/manage/school-admins${forceSchool}`})
    links.push({name: 'Manage Teachers', link: `/users/manage/teachers${forceSchool}`})
  }
  if (hasPermissionQ('Teacher', role)) {
    let forceTeacher = ''
    let forceSchool = ''
    if (role === 'Teacher') {
      forceTeacher = `/${user.id}`
      forceSchool = `/${user.school}`
    } else if (role === 'School Admin') {
      forceSchool = `/${user.school}`
    }
    links.push({name: 'Manage Classes', link: `/users/manage/classes${forceTeacher}`})
    links.push({name: 'Manage Students', link: `/users/manage/students${forceSchool}`})
    //links.push({name: 'Manage Codes', link: `/users/manage/codes${forceTeacher}`})
  }

  return links
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/getManageUsersSidebarLinks.js